var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterveneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23235_2769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2086 6.91648C10.893 7.49698 10.98 7.57767 11.2812 7.83705C11.5019 7.64777 11.6912 7.47558 12.4938 6.80252C13.9669 5.56561 15.0312 4.67252 15.0312 3.35327C15.0312 2.10264 14.1125 1.12305 12.9396 1.12305C12.1518 1.12305 11.6291 1.56755 11.3009 2.02027C10.99 1.56617 10.4847 1.12305 9.69458 1.12305C8.5218 1.12305 7.60352 2.10267 7.60352 3.35327C7.60348 4.70595 8.63989 5.5853 10.2086 6.91648Z",
    fill: "#5A608D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68128 14.6231C3.90941 13.7888 5.25319 13.47 6.71569 13.7138L9.05944 14.1169C9.95947 14.2669 10.7844 14.22 11.4969 13.9856C12.9709 13.4944 14.4465 11.9472 14.8376 11.3606C15.3813 10.545 15.6801 9.65439 15.8676 9.22317C16.0457 8.81067 16.0457 8.52004 15.8582 8.35129C15.6426 8.15439 15.277 8.25751 15.0051 8.40754C14.5738 8.65129 14.1157 9.35442 13.6469 10.0294C13.0376 10.9106 11.9938 11.4356 10.9251 11.4356H8.00003C7.74115 11.4356 7.53128 11.2258 7.53128 10.9669C7.53128 10.708 7.74115 10.4981 8.00003 10.4981H8.93753C11.4313 10.4981 12.5469 10.0294 12.5469 9.56064C12.5469 9.16692 11.7688 8.98876 11.5063 8.93254C10.4844 8.69817 8.17813 8.58567 6.60316 7.88254C6.31913 7.75826 5.99713 7.68851 5.65634 7.68564C5.12203 7.68111 4.54134 7.84757 3.9875 8.27626C3.97819 8.27626 3.97819 8.27626 3.96878 8.28564C3.60316 8.56689 3.10316 8.97939 2.42816 9.57001C1.85625 10.0762 1.30316 10.7231 0.3375 11.5481L0 11.8388L2.30628 14.8763L2.68128 14.6231Z",
    fill: "#5A608D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23235_2769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterveneIcon);
export default __webpack_public_path__ + "static/media/intervene-icon.0038e356.svg";
export { ForwardRef as ReactComponent };